<template>
  <div class="page">
    <Navbar />
    <Banner :haSingleImg="false" :hasBgBlur="true" :galeria="evento.galeria" />
    <v-container>
      <v-col>
        <v-row>
          <Title
            :sub1="evento.categoria"
            :titulo="evento.nome"
            :sub2="evento.data"
            :hasVideo="hasVideo"
            :video="evento.video"
          />
        </v-row>

        <v-row>
          <vue-simple-markdown class="body-1" :source="evento.descricao"></vue-simple-markdown>
        </v-row>
      </v-col>
    </v-container>
    <Footer />
  </div>
</template>



<script>
import Navbar from "@/components/Navbar.vue";
import Title from "@/components/Title.vue";
import Banner from "@/components/Banner.vue";
import Footer from "@/components/Footer.vue";
import { getLangValue } from "@/globalFunctions.js";
import _ from "lodash";

export default {
  name: "Home",
  components: {
    Navbar,
    Banner,
    Title,
    Footer
  },
  destroyed() {
    this.evento = {};
    this.id = null;
  },
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  async mounted() {
    await this.getTitulos();
    await this.getData();
  },
  data() {
    return {
      id: this.$route.params.id,
      hasVideo: false,
      evento: {},
      titulos: []
    };
  },
  methods: {
    async getData() {
      var _evento = await this.$store.dispatch(
        "setEvento",
        this.$route.params.id
      );

      if (_evento.data_fim == "") {
        _evento.data = _evento.data_inicio;
      } else {
        _evento.data =
          _evento.data_inicio + " " + this.titulos[0] + " " + _evento.data_fim;
      }

      if (_.isNull(_evento.video)) {
        this.hasVideo = false;
      } else {
        this.hasVideo = true;
      }

      this.evento = _evento;
    },
    btnShare(id) {
      var btnShare = document.getElementById(id);
      btnShare.click();
    },
    async getTitulos() {
      var conectoresAte = await getLangValue(
        "Conectores",
        "a",
        this.$store.getters.language
      );

      this.titulos.push(conectoresAte);
    }
  }
};
</script>
